import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M8 6h8c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2z"
}), 'StopRounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/StopRounded.js
// module id = 6505
// module chunks = 2